import * as _ from "lodash";
import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import moment from "moment";
import { withTranslation } from "react-i18next";

import * as styles from "./style.css";
import { createClassNames } from "../../../../../infrastructure/helpers";
import { getUserAvatarUrl } from "../../../domain/services/StickerHelpers";

class StickersComponentsCommentsList extends PureComponent {

  _commentsList = null;
  _rerenderTimer = null;

  static defaultProps = {
    comments: []
  };

  static propTypes = {
    comments: PropTypes.any
  };

  constructor(props) {
    super(props);
    this.state = {
      commentsListLayout: null,
      rerenderListFlag: false
    };
  }

  componentDidMount() {
    this._commentsList.scrollTop = this._commentsList.scrollHeight;
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.comments && nextProps.comments.length > 0 && this._rerenderTimer == null) {
      this.startRerenderTimer();
    }
    if (nextProps.comments !== this.props.comments) {
      this.scrollCommentsToEnd();
    }
  }

  componentWillUnmount() {
    if (this._rerenderTimer != null) {
      clearInterval(this._rerenderTimer);
      this._rerenderTimer = null;
    }
  }

  startRerenderTimer() {
    this._rerenderTimer = setInterval(() => {
      this.setState({ rerenderListFlag: !this.state.rerenderListFlag });
    }, 20 * 1000);
  }

  commentsListRef = (ref) => {
    this._commentsList = ref;
  };

  scrollCommentsToEnd = () => {
    setTimeout(() => {
      this._commentsList.scrollTop = this._commentsList.scrollHeight;
    }, 500);
  };

  _renderComment(comment, index, array) {
    const authorName = _.get(comment, 'created_by.display_name') || this.props.t('defaultName');
    const momentDate = moment(comment.created_date);
    const date = moment().diff(momentDate, 'days') >= 1 ? momentDate.format('MMM D, hh:mm A') : momentDate.fromNow();
    const isLast = index === array.length - 1;
    const itemStyles = [styles.comment];

    if (isLast) itemStyles.push(styles.commentLast);

    const itemClass = createClassNames(itemStyles);

    const { thumbSource } = getUserAvatarUrl(comment.created_by);

    return (
      <div key={comment.id} className={itemClass}>
        { !comment.is_user_read && (<div className={styles.commentUnread} />) }
        <div className={styles.commentAvatarWrap}>
          <img src={thumbSource} className={styles.commentAvatar} />
        </div>
        <div className={styles.commentContent}>
          <div className={styles.commentAuthorName}>{authorName}</div>
          <div className={styles.commentMessage}>{comment.text}</div>
          <div className={styles.commentDate}>{date}</div>
        </div>
      </div>
    )
  }

  render() {
    return (
      <div className={styles.commentsList}
           ref={this.commentsListRef}>
        { <div className={styles.commentsListTopOverlay}/> }
        {this.props.comments.map((comment, index, array) => this._renderComment(comment, index, array))}
      </div>
    );
  }
}

export default withTranslation('cmp-comments-list')(StickersComponentsCommentsList);


// WEBPACK FOOTER //
// ./src/app/modules/stickers/ui/components/comments-list/index.jsx